export default __webpack_public_path__ + "static/media/profile4.70c4c65c.png";